// Imports
import { faUser } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import styled from 'styled-components/macro';
import { baseLinkStyle, StyledLink } from '../../shared-components/styled-hyperlinks';
import SignInAnchor from '../../sign-in-anchor';


// Styled components
const UserIconContainer = styled.div`
	grid-column: 1;
	padding-top: 7%;
	padding-left: 0.1875rem;
	
	font-size: 1rem;
	line-height: 2rem;
`;

const SignInContainer = styled.div`
	grid-column: 2;
	font-size: 1.5625rem;
	line-height: 1.5625rem;
	margin-left: 0.0625rem;
	margin-top: 0.1563rem;
	
	div {
		margin-top: 0.1563rem;
		font-size: 0.9375rem;
	}
	
	a {
		${baseLinkStyle}
	}
`;


// Function component
const SignIn: React.FC = () => {
	// Return JSX
	return (
		<React.Fragment>
			<UserIconContainer>
				<FontAwesomeIcon icon={faUser} size='2xl' />
			</UserIconContainer>
			
			<SignInContainer>
				<span>Welcome!</span>
				<div>
					Please <SignInAnchor>sign in</SignInAnchor> or <StyledLink to='/account/register'>register</StyledLink>.
				</div>
			</SignInContainer>
		</React.Fragment>
	);
};

export default SignIn;
